import { IPublicUserModel } from '../repositories/users/entities/UserDataModels/PublicUserModel';
import { TUser } from '../types/user/user';

export function userMapper(user: IPublicUserModel | null | undefined): TUser {
  if (!user) {
    return null;
  }

  const { phone, phoneConfirmed, email, cianUserId, realtyUserId, firstName, lastName, displayName } = user;

  return {
    phone,
    phoneConfirmed,
    email,
    cianUserId,
    userId: realtyUserId,
    firstName,
    lastName,
    displayName,
  };
}
